import * as MediaQuery from 'react-responsive';
import * as React from 'react';
import * as firebase from 'firebase';

import { Partner, Role, StudioAppConfig } from 'glance-datatypes';
import { cyan500, red500, purple500 } from 'material-ui/styles/colors';

import Divider from 'material-ui/Divider';
import FontIcon from 'material-ui/FontIcon';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import RestService from '../RestService';
import TextField from 'material-ui/TextField';
import Utils from '../Utils';

const firebaseConfig = {
  apiKey: 'AIzaSyCYzP216jLWeSjFIxQcQ2c3RXgmTBvG7bU',
  authDomain: 'vault-24754.firebaseapp.com',
  databaseURL: 'https://vault-24754.firebaseio.com',
  storageBucket: 'vault-24754.appspot.com',
  messagingSenderId: '355957702177',
};

firebase.initializeApp(firebaseConfig);

const styles = {
  section: {
    width: '100%',
    height: '100%',
    position: 'fixed',
    backgroundColor: cyan500,
    display: 'flex',
    maxWidth: 'none',
  },
  div: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'initial',
    resize: 'verticle',
    width: '30%',
    height: '70%',
    margin: 'auto',
  },
  header: {
    margin: '5% auto',
    color: 'white',
    background: 'url(../../../assets/images/logo_white.png) no-repeat',
    backgroundSize: '40px',
    paddingLeft: '50px',
    backgroundPositionX: '0px',
    fontSize: '34px',
    lineHeight: '40px',
    textAlign: 'center',
  },
  headerMobile: {
    color: 'white',
    background: 'url(../../../assets/images/logo_white.png) no-repeat',
    backgroundSize: '40px',
    paddingTop: '50px',
    backgroundPositionX: 'center',
    backgroundPositionY: '0px',
    fontSize: '34px',
    lineHeight: '40px',
    textAlign: 'center',
  },
  paper: {
    padding: '3%',
    textAlign: 'center',
    display: 'block',
    resize: 'verticle',
  },
  textField: {
    width: '100%',
    maxWidth: '300px',
    display: 'block',
    margin: 'auto',
  },
  raisedButton: {
    margin: '2%',
    marginTop: '2%',
    marginBottom: '5%',
    width: '50%',
  },
  raiseGoogleButton: {
    color: red500,
    marginTop: '5%',
    marginBottom: '5%',
    width: '50%',
  },
  raiseMicrosoftButton: {
    color: purple500,
    marginTop: '5%',
    marginBottom: '5%',
    width: '50%',
  },
  errorStyle: {
    color: red500,
    margin: '5px auto',
    textAlign: 'center',
  },
};

function findGetParameter(parameterName) {
  let result = null,
    tmp = [];
  console.log(location);
  location.href
    .substr(location.href.indexOf('?') + 1)
    .split('&')
    .forEach(function(item) {
      tmp = item.split('=');
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  if (result && result.indexOf('id_token') > -1) {
    return '/';
  }
  console.log(result);
  return result;
}

function createMicrosoftLoginUrl() {
  let options = {
    loginURl: 'https://login.microsoftonline.com',
    path: 'oauth2/v2.0/authorize',
    tenantId: '89359cf4-9e60-4099-80c4-775a0cfe27a7',
    clientId: '9e371d68-883c-4e25-8a43-7fe4e0c02e6a',
    responseType: 'id_token',
    redirect_uri: '/',
    scope: 'openid+offline_access+profile+email',
    responseMode: 'fragment',
    nonce: '678910',
    state: '12345',
  };
  return `${options.loginURl}/${options.tenantId}/${options.path}?client_id=${
    options.clientId
  }&response_type=${options.responseType}&redirect_uri=${window.location
    .origin + options.redirect_uri}&scope=${options.scope}&response_mode=${
    options.responseMode
  }&state=${options.state}&nonce=${options.nonce}`;
}

interface Props {
  history?: any;
  location?: any;
  checkingForLogin?: boolean;
  partnerMap?: Map<string, Partner>;
  appConf: StudioAppConfig;
}

interface State {
  email?: string;
  password?: string;
  logginFailed?: boolean;
  logginSucces?: boolean;
  partnerMap?: Map<string, Partner>;
  appConf: StudioAppConfig;
}

class LoginComponent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      logginFailed: false,
      appConf: this.props.appConf,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.loginUsingGoogle = this.loginUsingGoogle.bind(this);
    this.loginGoogleUserToDashboard = this.loginGoogleUserToDashboard.bind(
      this,
    );
    this.loginUsingMicrosoftPortal = this.loginUsingMicrosoftPortal.bind(this);
    this.loginUsingMicrosoftAuth = this.loginUsingMicrosoftAuth.bind(this);
  }

  componentDidMount() {
    // var that = this
    // setTimeout(function(){
    //     that.setState({
    //         ...that.state,
    //         checkingForLogin: false
    //     })
    // }, 3000)
    if (window.location.href.indexOf('id_token=') > -1) {
      let obj = window.location.href.split('id_token=');
      obj = obj[1].split('&');
      this.loginUsingMicrosoftAuth(obj[0]);
    }
  }

  loginUsingMicrosoftPortal() {
    window.location.replace(createMicrosoftLoginUrl());
  }
  shouldShowLogin(): boolean {
    const path: string = this.props.location.pathname;
    let showLogin: boolean = false;
    const pathEnd = path.indexOf('/', 1);
    if (path.substr(1, pathEnd == -1 ? path.length - 1 : pathEnd) === 'login')
      showLogin = true;
    return showLogin;
  }

  handleChange = (event: any) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      ...this.state,
      [name]: value,
      logginFailed: false,
    });
  };

  handleGoogleAuthSuccess = (response: any) => {
    const token = response['accessToken'] as string;
    this.loginGoogleUserToDashboard(token);
  };

  handleGoogleAuthFailure = (response: any) => {
    console.error(response);
  };

  loginUsingGoogle() {
    let provider = new firebase.auth.GoogleAuthProvider();
    let that = this;
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(function(result) {
        let token = result.credential.accessToken;
        that.loginGoogleUserToDashboard(token);
      })
      .catch(function(error: any) {
        console.error(error);
      });
  }
  loginUsingMicrosoftAuth(token: string) {
    this.setState({
      ...this.state,
      logginSucces: true,
    });
    RestService.loginUsingMicrosoftAuth(token, this.setUserRoles);
  }
  setUserRoles = (data: any) => {
    if (data == null) {
      console.log('login failed');
    } else {
      const redirect = findGetParameter('redirect');
      if (redirect) {
        console.log('redirecting to', redirect);
        this.props.history.push(redirect);
        window.location.reload();
      } else {
        switch (data.role) {
          case Role.ADMIN:
            this.props.history.push('/moderator');
            break;
          case Role.CURATOR:
            this.props.history.push('/curator');
            break;
          case Role.DESIGNER:
            this.props.history.push('/designer');
            break;
          case Role.MODERATOR:
            this.props.history.push('/moderator');
            break;
          default:
            console.error('Undefined role', data.role);
          // that.props.history.push("/logout")
          // window.location.reload()
        }
      }
      // this.props.history.push('/')
    }
  };

  loginGoogleUserToDashboard(token: string) {
    this.setState({
      ...this.state,
      logginSucces: true,
    });
    RestService.loginUsingGoogleAuth(token, this.setUserRoles);
  }

  onSubmit() {
    console.log('onSubmit');
    let that = this;
    RestService.loginUsingEmailAndPassword(
      this.state.email,
      this.state.password,
      function(data: any) {
        if (data == null) {
          that.setState({
            ...that.state,
            logginFailed: true,
          });
        } else {
          console.log(data);
          const redirect = findGetParameter('redirect');
          if (redirect) {
            console.log('redirecting to', redirect);
            that.props.history.push(redirect);
            window.location.reload();
          } else {
            switch (data.role) {
              case Role.PARTNER:
                that.props.history.push('/partner');
                window.location.reload();
                break;
              case Role.ADMIN:
                that.props.history.push('/admin');
                window.location.reload();
                break;
              default:
              // that.props.history.push("/logout")
              // window.location.reload()
            }
            // this.props.history.push('/')
          }
        }
      },
    );
  }

  render() {
    // console.log('New login component')
    const loginCard =
      this.state.logginSucces || this.state.appConf ? (
        <Paper style={styles.paper} zDepth={3}>
          <h3> Login Successful. Opening the gate ... </h3>
        </Paper>
      ) : (
        <Paper style={styles.paper} zDepth={3}>
          {this.state.logginFailed ? (
            <span style={styles.errorStyle}>
              Login failed. Incorrect email or password
            </span>
          ) : (
            ''
          )}
          <form
            onSubmit={(e) => {
              e.preventDefault();
              this.onSubmit();
            }}
          >
            <TextField
              key="email"
              style={styles.textField}
              floatingLabelText="Email"
              type="text"
              name="email"
              onChange={this.handleChange}
            />
            <TextField
              key="password"
              style={styles.textField}
              floatingLabelText="Password"
              type="password"
              name="password"
              onChange={this.handleChange}
            />
            <RaisedButton
              label="Email Login"
              type="submit"
              primary={true}
              style={styles.raisedButton}
              icon={
                <FontIcon className="material-icons">account_circle</FontIcon>
              }
            />
          </form>
          <Divider />
          <RaisedButton
            label="Gmail Login"
            primary={true}
            onClick={this.loginUsingGoogle}
            style={styles.raiseGoogleButton}
            buttonStyle={{ backgroundColor: red500 }}
            icon={
              <FontIcon className="material-icons">account_circle</FontIcon>
            }
          />
          <Divider />
          <RaisedButton
            label="Microsoft"
            primary={true}
            onClick={this.loginUsingMicrosoftPortal}
            style={styles.raiseMicrosoftButton}
            buttonStyle={{ backgroundColor: purple500 }}
            icon={
              <FontIcon className="material-icons">account_circle</FontIcon>
            }
          />
        </Paper>
      );

    return (
      <section style={styles.section}>
        <MediaQuery query="(min-device-width: 1224px)">
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              resize: 'verticle',
              width: '30%',
              height: '70%',
              margin: 'auto',
            }}
          >
            <h1 style={styles.header}>
              {' '}
              Glance For {Utils.getDomainPrefix()}{' '}
            </h1>
            {loginCard}
          </div>
        </MediaQuery>
        <MediaQuery query="(max-device-width: 1224px)">
          {(matches) => {
            if (matches) {
              console.log('mobile device');
              return (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    resize: 'verticle',
                    width: '90%',
                    height: '90%',
                    margin: 'auto',
                    overflow: 'auto',
                  }}
                >
                  <h1 style={styles.headerMobile}>
                    {' '}
                    Glance For {Utils.getDomainPrefix()}
                  </h1>
                  {loginCard}
                </div>
              );
            } else {
              return null;
            }
          }}
        </MediaQuery>
      </section>
    );
  }
}

export default LoginComponent;



// WEBPACK FOOTER //
// ./src/components/LoginComponent.tsx